import { Image } from 'antd'
import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'

function MiddleOfHeader() {
  const hostname = useHostname()
  const bannerImgLink = BaseConfig[hostname]?.header?.bannerImg
  return (
    <div id="company-info" className="d-flex flex-column py-1 fs-6">
      {bannerImgLink && (
        <Image
          preview={false}
          className="h-50px"
          src={bannerImgLink}
          alt="logo"
        />
      )}
    </div>
  )
}

export default MiddleOfHeader
